angular.module("NumbersEditor").filter('ToGameDesc', function () {
    return function (input) {
        switch (input) {
            case "I":
                return "Initial";
            case "O":
                return "On";
            case "V":
                return "Void";
            case "C":
                return "Cancelled";
            default:
                return "STATUS DESC NOT FOUND";
        }
    };
});